import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ba6d344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-5 pb-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(`w-full grid grid-cols-11`)
}
const _hoisted_5 = { class: "px-2 py-2 my-auto flex items-center justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "material-icons text-accept"
}
const _hoisted_7 = {
  key: 1,
  class: "material-icons text-red-600"
}
const _hoisted_8 = { class: "px-2 py-3 my-auto text-center col-span-2" }
const _hoisted_9 = { class: "px-2 py-3 my-auto text-center col-span-2" }
const _hoisted_10 = { class: "px-2 py-3 my-auto text-center col-span-2" }
const _hoisted_11 = { class: "px-2 py-3 my-auto text-center col-span-2" }
const _hoisted_12 = { class: "px-2 py-3 my-auto text-center col-span-2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  class: "px-3 py-3",
  style: {"height":"400px"}
}
const _hoisted_15 = { class: "w-full flex items-center justify-center pb-3" }
const _hoisted_16 = {
  key: 1,
  class: "p-3"
}
const _hoisted_17 = {
  key: 2,
  class: "flex justify-center items-center",
  style: {"height":"120px"}
}
const _hoisted_18 = {
  key: 3,
  class: "p-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModelAnswerListHeader = _resolveComponent("ModelAnswerListHeader")!
  const _component_MonacoEditorDiff = _resolveComponent("MonacoEditorDiff")!
  const _component_MonacoEditorRead = _resolveComponent("MonacoEditorRead")!
  const _component_IconTextButton = _resolveComponent("IconTextButton")!
  const _component_NestedElement = _resolveComponent("NestedElement")!
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_ButtonPanel = _resolveComponent("ButtonPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ButtonPanel, {
      buttonIcon: 'refresh',
      click: _ctx.refresh,
      icon: "group",
      title: `${_ctx.$t(`message.modelAnswer`)} (${_ctx.programLanguage})`
    }, {
      default: _withCtx(() => [
        (_ctx.sortedModelAnswerList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ModelAnswerListHeader),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedModelAnswerList, (modelAnswer) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: modelAnswer.judgeId
                }, [
                  (_ctx.hasDataInExpandedList(modelAnswer.judgeId).value && _ctx.hasDataInLoadingList(modelAnswer.judgeId).value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_NestedElement, {
                          isSummaryExpanded: _ctx.modelAnswerExpandedList[modelAnswer.judgeId],
                          loading: _ctx.modelAnswerLoadingList[modelAnswer.judgeId],
                          onClickSummary: ($event: any) => (_ctx.clickSummary(modelAnswer.judgeId))
                        }, {
                          labels: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                (modelAnswer.policy == 'public')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " visibility "))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_7, " visibility_off "))
                              ]),
                              _createElementVNode("div", _hoisted_8, _toDisplayString(modelAnswer.judgeId), 1),
                              _createElementVNode("div", _hoisted_9, _toDisplayString(modelAnswer.userId), 1),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(modelAnswer.rating.toFixed(2)), 1),
                              _createElementVNode("div", _hoisted_11, _toDisplayString((modelAnswer.cpuTime / 100).toFixed(2)) + " sec ", 1),
                              _createElementVNode("div", _hoisted_12, _toDisplayString(modelAnswer.codeSize) + " B", 1)
                            ])
                          ]),
                          body: _withCtx(() => [
                            (_ctx.modelAnswerSourceCodeList[modelAnswer.judgeId])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    (_ctx.modelAnswerIsDiffList[modelAnswer.judgeId])
                                      ? (_openBlock(), _createBlock(_component_MonacoEditorDiff, {
                                          key: 0,
                                          class: "h-full border dark:border-dark-400",
                                          modelSourceCode: _ctx.modelAnswerSourceCodeList[modelAnswer.judgeId]
                                        }, null, 8, ["modelSourceCode"]))
                                      : (_openBlock(), _createBlock(_component_MonacoEditorRead, {
                                          key: 1,
                                          class: "h-full border dark:border-dark-400",
                                          value: _ctx.modelAnswerSourceCodeList[modelAnswer.judgeId]
                                        }, null, 8, ["value"]))
                                  ]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_IconTextButton, {
                                      border_radius: 2,
                                      class: "mx-1",
                                      font_weight: '700',
                                      icon: 'difference',
                                      iconSize: 'text-xl',
                                      padding_bottom: 4,
                                      padding_left: 12,
                                      padding_right: 12,
                                      padding_top: 4,
                                      text: 'Diff',
                                      textSize: 'text-base',
                                      onClick: ($event: any) => (_ctx.reverseModelAnswerIsDiffFlag(modelAnswer.judgeId))
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_IconTextButton, {
                                      border_radius: 2,
                                      class: "mx-1",
                                      font_weight: '700',
                                      icon: 'content_copy',
                                      iconSize: 'text-xl',
                                      padding_bottom: 4,
                                      padding_left: 12,
                                      padding_right: 12,
                                      padding_top: 4,
                                      text: _ctx.$t('message.copy'),
                                      textSize: 'text-base',
                                      onClick: ($event: any) => (_ctx.copyClipboard(_ctx.modelAnswerSourceCodeList[modelAnswer.judgeId]))
                                    }, null, 8, ["text", "onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["isSummaryExpanded", "loading", "onClickSummary"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_ctx.sortedModelAnswerList.length <= 0 && !_ctx.modelAnswerListLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('message.noData')), 1))
            : _createCommentVNode("", true),
        (_ctx.modelAnswerListLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_LoadingPanel)
            ]))
          : (_ctx.modelAnswerListError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('message.error')), 1))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["click", "title"])
  ]))
}